/**
 * 导入工具类
 */
import { bridgeCallHandler } from '../../core';
import { printNativeMethodFallback } from '../../internal';
import { isInApp } from '../../utils';

/**
 * 导入类型声明
 */
import type { BridgeResponseCallback } from '../../types';

/**
 * 调用客户端打开相册选择图片
 * @param callback
 */
export const chooseImage = (callback: BridgeResponseCallback): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('chooseImage', 'chooseImage');
    return;
  }
  bridgeCallHandler('chooseImage', '', callback);
};

/**
 * 调用客户端打开拍照
 * @param callback
 * @returns
 */
export const openCamera = (callback: BridgeResponseCallback): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('openCamera', 'openCamera');
    return;
  }

  bridgeCallHandler('openCamera', '', callback);
};

/**
 * 调用客户端批量选择图片
 * @param callback
 * @returns
 */
export const chooseImageMulti = (count: number, callback: BridgeResponseCallback): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('chooseImageMulti', 'chooseImageMulti');
    return;
  }

  bridgeCallHandler('chooseImageMulti', String(count), callback);
};

/**
 * 保存图片到相册
 */
export const saveImageToNative = (value: string): void => {
  if (!isInApp()) {
    printNativeMethodFallback('saveImageToNative', 'saveImageToNative');
    return;
  }
  bridgeCallHandler('saveImageToNative', value, null);
};

/**
 * 打开原生预览图片弹窗
 */
export const showNativePreviewDialog = (value: string): void => {
  if (!isInApp()) {
    printNativeMethodFallback('showNativePreviewDialog', 'showNativePreviewDialog');
    return;
  }
  bridgeCallHandler('showNativePreviewDialog', value, null);
};

/**
 * 直播视频跳到具体时间点
 */
export const jumpToSpecifiedTime = (value: string): void => {
  if (!isInApp()) {
    printNativeMethodFallback('jumpToSpecifiedTime', 'jumpToSpecifiedTime');
    return;
  }
  bridgeCallHandler('jumpToSpecifiedTime', value, null);
};

/**
 * 预览webview(带透明底)
 */
export const showWebPreviewDialog = (value: string): void => {
  if (!isInApp()) {
    window.open(value);
    return;
  }
  bridgeCallHandler('showWebPreviewDialog', value, null);
};
